import React from 'react';
import HintBodyLayout from './hintBodyLayout';
import { cardHintItems } from '../Card/constants';

const CardHint = () => (
  <div className="m-0 bottom-0 w-100 h-100 position-fixed mh-100 overflow-y-scroll">
    <HintBodyLayout data={cardHintItems} path="/dashboard/card/details" />
  </div>
);

export default CardHint;
